import pym from 'pym.js';
window.pym = pym;

import dataTrackMap from './helpers/data_track_prop_map'
if (typeof window !== 'undefined') {
  window.oc = window.oc || {};
  window.oc.dataTrackMap = dataTrackMap;
}
